import createTabManager from './tabManagerFactory'
import tabs from 'components/Customer/ContractManagementContent/tabs'

const contractManagementSubTabs = createTabManager(tabs)

export default contractManagementSubTabs



// WEBPACK FOOTER //
// ./client/store/modules/tabs/contractManagementSubTabs.js